export enum Range {
    month,
    alltime
}